import React from 'react';

export default function Badge(props) {
    return (
        <div className="absolute bottom-0 top-0 left-0 right-0 px-2 py-1 flex items-start justify-end">
            <div className="xs_badge min-w-[20px] h-[16px] px-1 flex items-center justify-center font-medium text-xs bg-cs4 text-cs1 rounded-md">
                {props.content}
            </div>
        </div>
    );
}
